export const PersonalizationReducerv2 = (state =[],action)=>{
    switch (action.type) {
        case 'SET_PERSONALIZATION_DATA_V2':
            return {
                data:action.payload.data,
                expirationTime:Date.now() + (5*60*1000),
                shippingDetailsID:action.payload.shippingDetailsID,
                outletCode:action.payload.outletCode,
                correlationId:action.payload.correlationId,
                customerID:action.payload.customerID,
                isGuest:action.payload.isGuest,
                categories: action.payload.categories,
            }
        case 'RESET_PERSONALIZATION_DATA_V2':
            return [];
        default:
            return state;
    }
}